import { useMemo, useRef } from 'react';
// @ts-expect-error - lodash.isequal has no type declarations
import isEqual from 'lodash.isequal';
import { useSelector } from 'react-redux';

import Global from '../../../../store/global-selectors';
import type { WarehouseLocation } from './types';

export const useWarehouseLocations = (warehouseId: string | number | undefined): WarehouseLocation[] => {
  const rawWarehouseLocations = useSelector((state) =>
    Global.selectSellerInventoryWarehouseLocationsByWarehouseId(state, {
      inventoryWarehouseId: warehouseId,
    }),
  ) as WarehouseLocation[];

  const prevRef = useRef<WarehouseLocation[]>();

  return useMemo(() => {
    if (isEqual(prevRef.current, rawWarehouseLocations)) {
      return prevRef.current ?? [];
    }
    prevRef.current = rawWarehouseLocations;
    return rawWarehouseLocations ?? [];
  }, [rawWarehouseLocations]);
};
